import Footer from 'components/Footer';
import Header from 'components/HeaderNew';
import { Outlet } from 'react-router-dom';

const MainLayout = () => (
    <>
        <Header />
        <main>
            <Outlet />
        </main>
        <Footer />
    </>
);

export default MainLayout;
